import { getContractLinkList } from '@modusign/openapi-client-template';
import { useQuery } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

import ContractLinkListItem from '../../types/ContractLinkListItem';
import SearchContractLinkStatus from '../../types/SearchContractLinkStatus';

export const CONTRACT_LINK_LIST_QUERY_KEY = 'contractLinkList';

function useContractLinkList({
  enabled,
  limit,
  page,
  status,
  title,
  memberId,
  onSuccess,
}: {
  limit: number;
  page: number;
  status?: SearchContractLinkStatus;
  title?: string;
  enabled?: boolean;
  memberId?: string;
  onSuccess?: (data: { count: number; contractLinks: ContractLinkListItem[] }) => void;
}) {
  const workspaceId = useWorkspaceId();
  return useQuery<{ count: number; contractLinks: ContractLinkListItem[] }, Error>(
    [CONTRACT_LINK_LIST_QUERY_KEY, page, limit, status, title, memberId],
    () =>
      getContractLinkList(workspaceId, {
        limit,
        offset: (page - 1) * limit,
        status: status === 'ALL' ? undefined : status,
        title,
        memberId,
      }),
    { enabled: !!workspaceId && enabled, onSuccess }
  );
}

export default useContractLinkList;
